class exports.NonExistentUserDialog extends DialogHandler
    init: () ->
        @layoutUrl = 'backend/session-mgmt/missing-user'
        # @layoutUrl = 'backend/grower/layers/shapefile/missing-file'
        @classes = 'small_dialog'
        @resizable = false
        @createDialog()


    afterLoadLayout: () ->
        super()
        @openDialog()


    submitAction: () ->
        @destroy()
